import { combineReducers } from 'redux';
import loginReducer from '../pages/login/reducers'
import newTariffReducer from '../pages/NewTariff/reducers'
import dashboardReducer from '../pages/dashboard/reducers'
import bulkDataUploadReducer from '../pages/BulkUpload/reducers'
import  connectionReducer  from '../pages/ConnectionManagement/stateManagement/reducers';
import creditManagementReducer from '../pages/CreditManagement/reducers';
import notificatinReducer from '../pages/Notification/stateManegement/reducers';


const rootReducer = (state, action) => {
    const appReducer = combineReducers({
        loginReducer: loginReducer,
        newTariffReducer: newTariffReducer,
        dashboardReducer: dashboardReducer,
        bulkDataUploadReducer: bulkDataUploadReducer,
        connectionReducer:connectionReducer,
        creditManagementReducer: creditManagementReducer,
        notificatinReducer:notificatinReducer
    })
    return appReducer(state, action);
};

export default rootReducer;

